import { AuthService } from './../../shared/models/auth.service';
import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { PersonProfileModel } from './personprofile.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class PersonProfileService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetPersonByActivationCode(activationCode: string): Observable<IAPIResponse> {
    let getPersonUrl = WeGoConfig.API_GET_PERSONPROFILE_BY_ACTIVATION_CODE + "?activationCode=" + activationCode;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdatePersonProfile(personModel: PersonProfileModel): Observable<IAPIResponse> {
    let body = personModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });


    return this.http.post(WeGoConfig.API_POST_PERSONPROFILE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/personprofile/models/personprofile.service.ts